import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { GlobalContext } from "./Context/GlobalState";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import loaderGif from "../src/assest/Untitled design (5).gif";

export const PersonalDetailsModal = ({ show, onHide }) => {
  const { userData } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loanAmount, setLoanAmount] = useState(20000);
  const getPercentage = () => {
    const min = 20000;
    const max = 500000;
    return ((loanAmount - min) / (max - min)) * 100;
  };
  const [formData, setFormData] = useState({
    pan: "",
    name: "",
    aadhaar: "",
    dob: "",
    email: "",
    address: "",
    landmark: "",
    pincode: "",
    gender: "",
    occupation: "",
    property: "",
    monthlyIncome: "",
    ongoingLoan: "",
    ongoingEmi: "",
  });
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      monthlyIncome: loanAmount.toString(),
    }));
  }, [loanAmount]);

  const handleOngoingLoan = (value) =>
    setFormData((prev) => ({
      ...prev,
      ongoingLoan: value,
      ongoingEmi: value === "No" ? "0" : prev.ongoingEmi,
    }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleGender = (gender) => setFormData((prev) => ({ ...prev, gender }));
  const handleOccupation = (occupation) =>
    setFormData((prev) => ({ ...prev, occupation }));

  const handleSubmit = async () => {
    setLoading(true);

    const bodyData = {
      fkqid: userData.userid || "",
      fullname: formData.name,
      email: formData.email,
      purpose: "Personal Loan",
      dob: formData.dob,
      gender: formData.gender,
      pan: formData.pan,
      aadhaar: "string",
      occupation: formData.occupation,
      pincode: "string",
      property: formData.property,
      monthlyIncome: formData.monthlyIncome,
      isOngoing: formData.ongoingLoan === "Yes" ? "Y" : "N",
      ongoingEmiAmount:
        formData.ongoingLoan === "Yes" ? formData.ongoingEmi : "0",
    };

    try {
      const response = await fetch(
        "https://api.shubhpaisa.com/api/ShubhPaisa/InsertUserDetails",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyData),
        }
      );

      const data = await response.json();

      if (data.status === "0" && data.result?.[0]?.result === "Y") {
        onHide();
        navigate("/thank-you");
      } else {
        swal("Error", data.msg || "Failed to submit details", "error");
      }
    } catch (err) {
      swal("Error", "Network error, please try again.", "error");
    }

    setLoading(false);
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(2px)",
          }}
        >
          <img src={loaderGif} alt="loading" style={{ width: "20vw" }} />
        </div>
      )}
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header
          closeButton
          style={{ borderBottom: "none", padding: "1rem 1rem 0 1rem" }}
        >
          <Modal.Title className="fw-bold">Personal Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* PAN */}
          <div className="row mb-3">
            <div className="col-6">
              <label className="fw-semibold">Name as per PAN*</label>
              <input
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Name"
              />
            </div>
            <div className="col-6">
              <label className="fw-semibold">DOB as per PAN*</label>
              <input
                type="date"
                name="dob"
                className="form-control"
                value={formData.dob}
                onChange={handleChange}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-6">
              <label className="fw-semibold">PAN*</label>
              <input
                name="pan"
                className="form-control "
                placeholder="Enter Your PAN"
                value={formData.pan}
                onChange={handleChange}
              />
            </div>
            <div className="col-6">
              <label className="fw-semibold">Email*</label>
              <input
                name="email"
                className="form-control mb-3"
                placeholder="Enter Your Email ID"
                value={formData.email}
                onChange={handleChange}
              />
              {/* <label className="fw-semibold">Aadhaar*</label>
            <input
              name="aadhaar"
              className="form-control mb-3"
              placeholder="Enter Your Aadhaar Number"
              value={formData.aadhaar}
              onChange={handleChange}
            /> */}
            </div>
          </div>
          {/* Name + DOB */}

          {/* Email */}
          {/* <label className="fw-semibold">Email*</label>
        <input
          name="email"
          className="form-control mb-3"
          placeholder="Enter Your Email ID"
          value={formData.email}
          onChange={handleChange}
        /> */}

          {/* Address */}
          {/* <label className="fw-semibold">Address*</label>
        <input
          name="address"
          className="form-control mb-3"
          placeholder="Enter Your Address"
          value={formData.address}
          onChange={handleChange}
        /> */}

          {/* Landmark */}
          {/* <label className="fw-semibold">Landmark*</label>
        <input
          name="landmark"
          className="form-control mb-3"
          placeholder="Nearby Landmark"
          value={formData.landmark}
          onChange={handleChange}
        /> */}

          {/* Pincode */}
          {/* <label className="fw-semibold">Pincode*</label>
        <input
          name="pincode"
          className="form-control mb-4"
          placeholder="Enter Pincode"
          value={formData.pincode}
          onChange={handleChange}
        /> */}

          {/* Gender */}
          <label className="fw-semibold">Gender</label>
          <div className="d-flex gap-2 mb-2">
            {["Female", "Male", "Other"].map((g) => (
              <button
                key={g}
                type="button"
                className={`btn ${
                  formData.gender === g ? "btn-primary" : "btn-light"
                } w-100`}
                onClick={() => handleGender(g)}
              >
                {g === "Female" ? "👩" : g === "Male" ? "👨" : "🌈"} {g}
              </button>
            ))}
          </div>
          <label className="fw-semibold">Property Type</label>
          <div className="d-flex gap-2 mb-4">
            {["Self", "Parent", "Rent"].map((p) => (
              <button
                key={p}
                type="button"
                className={`btn ${
                  formData.property === p ? "btn-primary" : "btn-light"
                } w-100`}
                onClick={() =>
                  setFormData((prev) => ({ ...prev, property: p }))
                }
              >
                {p}
              </button>
            ))}
          </div>
          {/* Occupation */}
          <label className="fw-semibold">Occupation Type</label>
          <div className="d-flex gap-2 mb-4">
            {["Salaried", "Self Employed"].map((o) => (
              <button
                key={o}
                type="button"
                className={`btn ${
                  formData.occupation === o ? "btn-primary" : "btn-light"
                } w-100`}
                onClick={() => handleOccupation(o)}
              >
                {o === "Salaried" ? "💼" : "👨‍💻"} {o}
              </button>
            ))}
          </div>

          {formData.occupation && (
            <div className="mb-2">
              <label className="fw-semibold mb-2 d-block">Monthly Income</label>

              <div className="fw-bold text-primary mb-2">
                ₹ {loanAmount.toLocaleString("en-IN")}
              </div>

              <input
                type="range"
                min={20000}
                max={500000}
                step={5000}
                value={loanAmount}
                onChange={(e) => setLoanAmount(Number(e.target.value))}
                className="form-range"
              />

              <div className="d-flex justify-content-between text-muted small">
                <span>₹20,000</span>
                <span>₹5,00,000</span>
              </div>
            </div>
          )}
          <label className="fw-semibold">Any Ongoing Loan?</label>
          <div className="d-flex gap-2 mb-3">
            {["Yes", "No"].map((v) => (
              <button
                key={v}
                type="button"
                className={`btn ${
                  formData.ongoingLoan === v ? "btn-primary" : "btn-light"
                } w-100`}
                onClick={() => handleOngoingLoan(v)}
              >
                {v === "Yes" ? "📄 Yes" : "❌ No"}
              </button>
            ))}
          </div>
          {formData.ongoingLoan === "Yes" && (
            <div className="mb-4">
              <label className="fw-semibold">Total Ongoing EMI (₹)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter monthly EMI amount"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    ongoingEmi: e.target.value,
                  }))
                }
              />
            </div>
          )}

          {/* Submit Button */}
          <button
            className="btn btn-primary w-100 py-2 fw-semibold"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

// export default PersonalDetailsModal;
